module.exports = __webpack_public_path__ + "static/media/MbBanescoContigoLogo.d33de354.svg";